import React from 'react'
import { NavLink } from 'react-router-dom'
import 'rc-calendar/assets/index.css'
import parse from 'html-react-parser'
import Grid from '@mui/material/Grid'
import EditIcon from '@mui/icons-material/Edit'
import CloseIcon from '@mui/icons-material/Close'
import DoneIcon from '@mui/icons-material/Done'
import { FormatHomePageMessage, DoesThisUserHavePermissionToEditTheFrontPageText } from '../utilities/helperFunctions'

class Ghirardelli extends React.Component {
    state = {
        message: false,
        messageField: this.props.message,
        notes: false,
        notesField: this.props.notes,
        hasPermissionToEditText: false,
        logoUrl1: '',
        logoUrl2: '',
        logoUrl3: '',
        IElogoUrl: ''

    }

    componentDidMount() {

        this.setState({ IElogoUrl: `${process.env.REACT_APP_STATIC_WEB}/images/IElogo1.png` })
        this.setState({ logoUrl1: `${process.env.REACT_APP_STATIC_WEB}/images/${this.props.customerID}/logo1.png` })
        this.setState({ logoUrl2: `${process.env.REACT_APP_STATIC_WEB}/images/${this.props.customerID}/logo2.png` })
        this.setState({ logoUrl3: `${process.env.REACT_APP_STATIC_WEB}/images/${this.props.customerID}/logo3.png` })

        if (this.props.currentUser !== null) {
            if (this.props.currentUser["id"] !== this.props.id) {
                // If we switched users, disable the edit entirely, we'll process this once all of the current user information is updated
                this.setState({ hasPermissionToEditText: false })
            } else {
                this.setState({ hasPermissionToEditText: DoesThisUserHavePermissionToEditTheFrontPageText(this.props.currentUser) })
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.currentUser !== null) {
            if (prevProps.currentUser === null) {
                // Update if we don't have a current user from previous props
                this.setState({ hasPermissionToEditText: DoesThisUserHavePermissionToEditTheFrontPageText(this.props.currentUser) })
            } else {
                // Check and update if we have confirmed the user has switched
                if (prevProps.currentUser["id"] !== this.props.currentUser["id"]) {
                    this.setState({ hasPermissionToEditText: DoesThisUserHavePermissionToEditTheFrontPageText(this.props.currentUser) })
                }
            }
        }
    }

    goToPresentations = (event) => {
        event.preventDefault()
        this.props.history.push("/presentations")
    }

    handleMessageSubmit = (event) => {
        event.preventDefault()
    }

    messageSubmit = (event) => {
        event.preventDefault()
        this.props.updateCustomerMessage(this.props.customerID, this.state.messageField)
        this.setState({ message: false })
    }

    handleNotesSubmit = (event) => {
        event.preventDefault()
    }

    notesSubmit = (event) => {
        event.preventDefault()
        this.props.updateCustomerNotes(this.props.customerID, this.state.notesField)
        this.setState({ notes: false })
    }

    changeMessage = (event) => {
        event.preventDefault()
        this.setState({ messageField: event.target.value })
    }

    changeNotes = (event) => {
        event.preventDefault()
        this.setState({ notesField: event.target.value })
    }

    messageCancel = (event) => {
        event.preventDefault()
        this.setState({ message: false })
    }

    notesCancel = (event) => {
        event.preventDefault()
        this.setState({ notes: false })
    }

    toggleMessage = (event) => {
        this.setState({ message: !this.state.message })
    }

    toggleNotes = (event) => {
        this.setState({ notes: !this.state.notes })
    }

    Capitalize(str) {
        if (str)
            return str.charAt(0).toUpperCase() + str.slice(1);
        else
            return ""
    }

    renderEditButton = (toggle) => {
        if (this.state.hasPermissionToEditText) {
            return <button onClick={toggle}>
                {' '}
                <EditIcon />
                {' '}
            </button>
        }
    }



    render() {
        return (<div className="mainWrapper">
            <div className="bodyPart2">
                <div className="contentWrapper">
                    <div className="dashTop2">
                        <div className="welcomeuserLeft">
                            <img src={this.state.logoUrl1} alt="BI Cloud" onError={(e) => { e.target.onerror = null; e.target.src = this.state.IElogoUrl }} />
                          
                        </div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <img src={this.state.logoUrl2} alt="BI Cloud" onError={(e) => { e.target.onerror = null; e.target.src = this.state.IElogoUrl }} />
                        </div>
                    </div> 
                    <div className="dashMiddle" style={{ backgroundColor: "#1e376d" }} >
                        <h3>Welcome&nbsp;{this.Capitalize(this.props.firstName)},</h3><h4>Let's get started&nbsp;&nbsp;</h4>        
                 
                    </div>

                    <div className="dashBottom">
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <div className="innerBoxes" style={{ border: "0px", height: "300px" }}>
                                    <h3>
                                        A Message From Category Leadership
                                        {this.renderEditButton(this.toggleMessage)}
                                    </h3>
                                    {!this.state.message ? (
                                        <div className="textBox">
                                            <p>
                                                {parse(FormatHomePageMessage(this.props.message) || 'This is the XP3 BI Cloud portal, click me to leave Updates for your team')}
                                            </p>
                                        </div>
                                    ) : (
                                        <div className="textBox">
                                            <textarea
                                                className="editableTextBox"
                                                value={
                                                    this.state.messageField
                                                    || 'This is the XP3 BI Cloud portal, click me to leave Updates for your team'
                                                }
                                                onKeyUp={this.handleMessageSubmit}
                                                onChange={this.changeMessage}
                                            />
                                            <div className="centerButtons">
                                                <button>
                                                    {' '}
                                                    <CloseIcon onClick={this.toggleMessage} />
                                                    {' '}
                                                </button>
                                                <button>
                                                    {' '}
                                                    <DoneIcon onClick={this.messageSubmit} />
                                                    {' '}
                                                </button>
                                            </div>
                                            </div>
                                    )}
                                
                                </div>

                                <div style={{ textAlign: "center", paddingTop: "5px" }}>
                                    <img src={this.state.logoUrl3} alt="BI Cloud" onError={(e) => { e.target.onerror = null; e.target.src = this.state.IElogoUrl }} />
                                </div>

                            </Grid>
                            <Grid item xs={12} md={6}>
                                <div className="innerBoxes" style={{ border: "0px" }}>
                                    <h3>
                                        Latest Files and Data Updates
                                        {this.renderEditButton(this.toggleNotes)}
                                    </h3>
                                    {!this.state.notes ? (
                                        <div className="textBox">
                                            <p>
                                                {parse(FormatHomePageMessage(this.props.notes) || 'This is the XP3 BI Cloud portal, click me to leave Updates for your team')}
                                            </p>
                                        </div>
                                    ) : (
                                        <div className="textBox">
                                            <textarea
                                                className="editableTextBox"
                                                value={
                                                    this.state.notesField
                                                    || 'This is the XP3 BI Cloud portal, click me to leave Updates for your team'
                                                }
                                                onChange={this.changeNotes}
                                                onKeyUp={this.handleNotesSubmit}
                                            />
                                            <div className="centerButtons">
                                                <button>
                                                    {' '}
                                                    <CloseIcon onClick={this.toggleNotes} />
                                                    {' '}
                                                </button>
                                                <button>
                                                    {' '}
                                                    <DoneIcon onClick={this.notesSubmit} />
                                                    {' '}
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                    <div class="welcomeFooter">
                        &nbsp;&nbsp;&nbsp;©Interactive Edge 2023&nbsp;&nbsp;&nbsp; 
                         <NavLink to="/privacy" data-name="Privacy"><span>Privacy</span></NavLink>&nbsp;&nbsp;&nbsp;
                         <NavLink to="/terms" data-name="Terms"><span>Terms of Use</span></NavLink>&nbsp;&nbsp;&nbsp;
                         <div style={{ float: "right" }}>Version {global.appVersion}&nbsp;&nbsp;&nbsp;</div>
                    </div>
                </div>
            </div>
        </div>)
    }
}

export default Ghirardelli 